import { PathLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { I18nService } from '../services';
import { lmExclusions } from './languageMarketExclusions';

@Injectable({
  providedIn: 'root',
})
export class LanguageLocationStrategy extends PathLocationStrategy {
  service: I18nService = I18nService.prototype;
  currentLanguage: string = '';

  prepareExternalUrl(internal: string): string {
    const reg: RegExp = I18nService.languageUrlRegex;
    let url: string = internal;
    if (url !== '/' && !lmExclusions.includes(url.substring(1)) && !reg.exec(url) && !reg.exec(`${url}/`)) {
      url = `/${this.currentLanguage || this.service.getCurrentParam()}${url}`;
    } else if (!url.includes('page-not-found')) {
      const urlArray: RegExpExecArray | null = reg.exec(url) || reg.exec(`${url}/`);
      if (!this.currentLanguage) {
        this.currentLanguage = urlArray ? urlArray[0].replace(/\//gi, '') : '';
      }
    }

    return url;
  }
}
